__turbopack_context__.v({
  "dropdownMenuItem": "jKyuia_dropdownMenuItem",
  "groupList": "jKyuia_groupList",
  "groupListItemLabel": "jKyuia_groupListItemLabel",
  "menuItemLink": "jKyuia_menuItemLink",
  "menuItemWrapper": "jKyuia_menuItemWrapper",
  "menuWrapper": "jKyuia_menuWrapper",
  "moreMenuItemsDropdownContainer": "jKyuia_moreMenuItemsDropdownContainer",
  "primaryToolbarButton": "jKyuia_primaryToolbarButton",
  "subGroupWrapper": "jKyuia_subGroupWrapper",
  "subNavWrapper": "jKyuia_subNavWrapper",
  "visible": "jKyuia_visible",
});
